import _styled from "styled-components";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/web.dom-collections.iterator.js";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import Box from "../../../Styled/Box";
import { RawButton } from "../../../Styled/Button";
import { GLYPHS, StyledIcon } from "../../../Styled/Icon";
import { SpacingSpan } from "../../../Styled/Spacing";
import Text, { TextSpan } from "../../../Styled/Text";
import { parseCustomMarkdownToReactWithOptions } from "../parseCustomMarkdownToReact";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const CollapseIcon = props => {
  var _props$light;
  let glyph = GLYPHS.opened;
  let glyphWidth = 8;
  let glyphRotation = 0;
  let glyphOpacity = 1;
  if (props.btnStyle === "plus") {
    glyph = props.isOpen ? GLYPHS.minus : GLYPHS.plus;
    glyphOpacity = props.isOpen ? 1 : 0.4;
  } else if (props.btnStyle === "checkbox") {
    glyph = props.isOpen ? GLYPHS.checkboxOn : GLYPHS.checkboxOff;
    glyphWidth = 13;
  } else {
    glyphRotation = props.isOpen ? 0 : -90;
    glyphOpacity = props.isOpen ? 1 : 0.4;
  }
  return /*#__PURE__*/_jsx(StyledIcon, {
    displayInline: true,
    styledWidth: "".concat(glyphWidth, "px"),
    light: (_props$light = props.light) !== null && _props$light !== void 0 ? _props$light : true,
    glyph: glyph,
    opacity: glyphOpacity,
    rotation: glyphRotation
  });
};
const Collapsible = observer(props => {
  var _props$light2, _props$light3;
  const [isOpen, setIsOpen] = useState();
  useEffect(() => setIsOpen(props.isOpen), [props.isOpen]);
  const toggleOpen = () => {
    const newIsOpen = !isOpen;
    // Only update isOpen state if onToggle doesn't consume the event
    if (!props.onToggle || !props.onToggle(newIsOpen)) setIsOpen(newIsOpen);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(_StyledRawButton, {
      fullWidth: true,
      onClick: toggleOpen,
      "aria-expanded": isOpen,
      "aria-controls": "".concat(props.title),
      activeStyles: true,
      children: [!props.btnRight && /*#__PURE__*/_jsx(CollapseIcon, _objectSpread(_objectSpread({}, props), {}, {
        isOpen: isOpen
      })), !props.btnRight && /*#__PURE__*/_jsx(SpacingSpan, {
        right: 1
      }), /*#__PURE__*/_jsx(TextSpan, _objectSpread(_objectSpread({
        textLight: (_props$light2 = props.light) !== null && _props$light2 !== void 0 ? _props$light2 : true,
        bold: true,
        medium: true
      }, props.titleTextProps), {}, {
        children: parseCustomMarkdownToReactWithOptions(props.title, {
          inline: true
        })
      })), props.btnRight && /*#__PURE__*/_jsx(SpacingSpan, {
        right: 1
      }), props.btnRight && /*#__PURE__*/_jsx(CollapseIcon, _objectSpread(_objectSpread({}, props), {}, {
        isOpen: isOpen
      }))]
    }), isOpen ? /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({}, props.bodyBoxProps), {}, {
      children: /*#__PURE__*/_jsx(Text, _objectSpread(_objectSpread({
        textLight: (_props$light3 = props.light) !== null && _props$light3 !== void 0 ? _props$light3 : true,
        small: true,
        id: "".concat(props.title)
      }, props.bodyTextProps), {}, {
        children: props.children
      }))
    })) : null]
  });
});
export default Collapsible;
var _StyledRawButton = _styled(RawButton).withConfig({
  displayName: "Collapsible___StyledRawButton",
  componentId: "sc-12o4uac-0"
})(["text-align:left;display:flex;align-items:center;"]);